import { Component, ElementRef, Input, OnInit } from '@angular/core';
import { EditorInputField, Section } from '../../../../editor-container/editor-model';
import { ContentElement, HeadFootEnum, GridCell, NormalizeEnumsService, ContentElementEnum } from '@urbannex/storethemes';
import { Subject, Subscription, take } from 'rxjs';
import { BorderPresetPopoverComponent } from '../../border-preset-popover/border-preset-popover.component';
import { ColorPickerPopoverComponent } from '../../color-picker-popover/color-picker-popover.component';
import { FontFamilyPopoverComponent } from '../../font-family-popover/font-family-popover.component';
import { FontSizePopoverComponent } from '../../font-size-popover/font-size-popover.component';
import { FontWeightPopoverComponent } from '../../font-weight-popover/font-weight-popover.component';
import { PaddingPresetPopoverComponent } from '../../padding-preset-popover/padding-preset-popover.component';
import { CellThemeEditorComponent } from '../../../cell-theme-editor/cell-theme-editor.component';
import { CellEditorStoreService } from '../../../cell-editor-store.service';
import { SectionBuilderStoreService } from '../../../sections-editor/shared-section-builder/section-builder-store.service';
import { NbDialogService, NbIconLibraries, NbPopoverDirective } from '@nebular/theme';
import { CssServicesService } from '../../../../services/css-services.service';
import { sectionEditorIcons } from '../../section-editor-dialog/section-dialog-menu-items';
import { TextEditorPopverComponent } from '../../text-editor-popver/text-editor-popver.component';
import { MarginPopoverComponent } from '../../margin-popover/margin-popover.component';
import { ActionPopoverComponent } from '../../action-popover/action-popover.component';

@Component({
  selector: 'kve-editor-dialog-footer',
  templateUrl: './editor-dialog-footer.component.html',
  styleUrls: ['./editor-dialog-footer.component.scss']
})
export class EditorDialogFooterComponent extends CellThemeEditorComponent implements OnInit {
  @Input() section: Section
  @Input() cellId: string
  @Input() tabbed: boolean
  contentElements: ContentElement[];

  layoutClass: string;
  headerFooterOption: HeadFootEnum;
  rendererType: string;

  themeRoot: HTMLElement;

  selectedCell: GridCell;
  selectedCell$: Subscription;

  selectedContent;
  selectedHeader;
  selectedWeight;
  selectedFontSize;
  selectedFontFam;
  selectedAlignment;
  selectedWidth;
  textColor: string;
  selectedDelcaration;
  /**
   * String representations of ContentElementEnum or the Enum itself
   * Used to determine which type of content element is being edited
   * Possible strings are:
   * Text, Action, Button, ByLine, Caption, Date, Header, Heading, HTML, Image, InputField, Link, List Item, Number, Select, Sub Header, Summary, SVG, Table, Transform
   */
  contentElementEnum: string | ContentElementEnum;

  selectedContainerLayout;

  fontSizes = [
    { name: "Tiny", value: "0.625rem", class: "fnt-size-tiny" },
    { name: "Small", value: "0.75rem", class: "fnt-size-small" },
    { name: "Medium Small", value: "0.875rem", class: "fnt-size-medium" },
    { name: "Standard", value: "0.9375rem", class: "fnt-size-standard" },
    { name: "Standard Large", value: "1rem", class: "fnt-size-standard-large" },
    { name: "Standard Larger", value: "1.125rem", class: "fnt-size-standard-larger" },
    { name: "Large", value: "1.375rem", class: "fnt-size-large" },
    { name: "Larger", value: "1.625rem", class: "fnt-size-larger" },
    { name: "Very Large", value: "1.875rem", class: "fnt-size-very-large" },
    { name: "Giant", value: "2rem", class: "fnt-size-gigantic" },
    { name: "Enormous", value: "2.25rem", class: "fnt-size-enormous" }
  ]

  widthOptions = [
    { name: "Full Width", value: "kve-fullwidth" },
    { name: "auto", value: "kve-autoWidth" },
  ]

  fontFams = [
    {
      name: "Arial",
      value: "Arial, sans-serif"
    },
    {
      name: "Courier New",
      value: "Courier New, monospace"
    },
    {
      name: "Georgia",
      value: "Georgia, serif"
    },
    {
      name: "Lato",
      value: "Lato, sans-serif"
    },
    {
      name: "Lobster",
      value: "Lobster, sans-serif"
    },
    {
      name: "Merriweather",
      value: "Merriweather, sans-serif"
    },
    {
      name: "Montserrat",
      value: "Montserrat, sans-serif"
    },
    {
      name: "Open Sans",
      value: "Open Sans, sans-serif"
    },
    {
      name: "Oswald",
      value: "Oswald, sans-serif"
    },
    {
      name: "PT Sans",
      value: "PT Sans, sans-serif"
    },
    {
      name: "Playfair Display",
      value: "Playfair Display,serif"
    },
    {
      name: "Raleway",
      value: "Raleway, sans-serif"
    },
    {
      name: "Roboto",
      value: "Robotto, sans-serif"
    },
    {
      name: "Roboto Condensed",
      value: "Roboto Condensed, sans-serif"
    },
    {
      name: "Roboto Slab",
      value: "Roboto Slab, sans-serif"
    },
    {
      name: "Source Sans 3",
      value: "Source Sans 3, sans-serif"
    },
    {
      name: "Ubuntu",
      value: "Ubuntu, sans-serif"
    }
  ]

  containerLayouts = [
    { name: "Content Top", class: "container-content-top" },
    { name: "Content Middle", class: "container-content-middle" },
    { name: "Content Bottom", class: "container-content-bottom" }
  ]

  paddingField: EditorInputField = {
    name: 'padding',
    title: 'Padding',
    type: 'padding',
    controlType: 'multiMeasure'
  }
  marginField: EditorInputField = {
    name: "margin",
    title: "Margin",
    type: "margin",
    controlType: "multiMeasure"
  }
  borderField: EditorInputField = {
    name: 'border',
    title: "Border",
    type: "border",
    controlType: "multiMeasure"
  }

  alignments = [
    { name: "Align Left", class: "justify-left" },
    { name: "Align Center", class: "justify-center" },
    { name: "Align Right", class: "justify-right" }
  ]

  layoutDeclarations = [
    { name: "Padding", declaration: "padding" },
    { name: "Margin", declaration: "margin" },
    { name: "Border", declaration: "border" },
    { name: "Width", declaration: "width" }
  ]

  valignments = [
    { name: "align-top", class: "container-align-top" },
    { name: "align-middle", class: "container-align-middle" },
    { name: "align-bottom", class: "container-align-bottom" }
  ]


  bgColors$: Subscription;
  pmColors$: Subscription;
  activeSelector$: Subscription;
  bgBasic: string[] = []
  bgPrimary: string[] = []
  bgAlt: string[] = []
  fillColors: string[];
  primaryColors: string[] = [];

  fillColor: string;

  headerTxTClr$: Subscription;
  footerTxtClr$: Subscription;
  textClr$: Subscription;

  headerTextColor: string;
  footerTextColor: string;

  destroy$ = new Subject<void>();
  valueAll = 0;

  textPop: any = TextEditorPopverComponent;
  textPopContext = { title: 'Edit Text', popoverType: 'textPopover', target: 'content', service: 'cellEditorStoreService' }

  component: any = ColorPickerPopoverComponent;
  backgroundPopContext = { title: 'Container Background Color', popoverType: 'bgColor', target: 'parent', service: 'cellEditorStoreService', property: 'background' }

  borderPop: any = BorderPresetPopoverComponent;
  borderPopContext = { title: 'Border', popoverType: 'borderPop', target: 'content', service: 'cellEditorStoreService' }
  parentBorderPopContext = { title: 'Container Border', popoverType: 'borderPop', target: 'parent', service: 'cellEditorStoreService' }
  paddingPop: any = PaddingPresetPopoverComponent;
  paddingPopContext = { title: 'Padding', popoverType: 'paddingPop', target: 'content', service: 'cellEditorStoreService' }

  marginPop: any = MarginPopoverComponent

  fontSizePop: any = FontSizePopoverComponent;
  fontWeightPop: any = FontWeightPopoverComponent;
  fontFamPop: any = FontFamilyPopoverComponent;

  actionPop: any = ActionPopoverComponent;

  constructor(
    cellEditorStoreService: CellEditorStoreService,
    sectionBuilderStoreService: SectionBuilderStoreService,
    cssService: CssServicesService,
    rootElement: ElementRef,
    dialogService: NbDialogService,
    private iconLibraries: NbIconLibraries,
    private normalizeEnumsService: NormalizeEnumsService) {
    super(cellEditorStoreService, sectionBuilderStoreService, cssService, rootElement, dialogService);
  }

  ngOnInit(): void {
    this.iconLibraries.registerSvgPack('content-icons', sectionEditorIcons);
    this.selectedCell$ = this.cellEditorStoreService.selectedCell$.subscribe(cell => {
      if (cell) {
        this.selectedCell = cell;
      }
    })
    this.activeSelector$ = this.cellEditorStoreService.activeSelector$.subscribe((contentElement: ContentElement) => {
      if (contentElement) {
        this.selectedContent = contentElement;
        this.contentElementEnum = this.normalizeEnumsService.normalise(this.selectedContent.contentElementEnum);
        console.log(this.contentElementEnum)
        // this.selectedContent = contentElement;
        // this.contentElementEnum = this.normalizeEnumsService.normalise(this.selectedContent.contentElementEnum);
      } else if (this.selectedCell) {
        if (this.selectedCell.contentElements && this.selectedCell.contentElements.length > 0) {
          this.selectedContent = this.selectedCell.contentElements[0];
          this.contentElementEnum = this.normalizeEnumsService.normalise(this.selectedContent.contentElementEnum);
          console.log(this.contentElementEnum)
        }
      }
    });
    /* this.activeSelector$ = this.sectionBuilderStoreService.selectedContent$.subscribe((selectedContent: any) => {
      console.log(selectedContent)
      if (selectedContent) {
        this.selectedContent = selectedContent;
        this.contentElementEnum = this.normalizeEnumsService.normalise(this.selectedContent.contentElementEnum);
        console.log(this.contentElementEnum)
      } else if (this.selectedCell) {
        if (this.selectedCell.contentElements && this.selectedCell.contentElements.length > 0) {
          this.selectedContent = this.selectedCell.contentElements[0];
          this.contentElementEnum = this.normalizeEnumsService.normalise(this.selectedContent.contentElementEnum);
          console.log(this.contentElementEnum)
        }
      }
    }) */

  }
  /**
   *
   * @param alignmentClass String class name to be added to the array of classes for a contentElement.
   * Options are: justify-left, justify-center, justify-right
   */
  setHorizontalAlign(alignmentClass) {
    this.cellEditorStoreService.activeSelector$.pipe(take(1)).subscribe(content => {
      console.log("content to be updated: " + content);
      // Remove existing alignment classes
      this.alignments.forEach(alignment => {
        if (content.classes.includes(alignment.class)) {
          const itmIndx = content.classes.indexOf(alignment.class);
          if (itmIndx !== -1) {
            content.classes.splice(itmIndx, 1);
          }
        }
      })
      content.classes.push(alignmentClass);
      const updatedContent: ContentElement = { ...content }
      this.cellEditorStoreService.updateActiveSelectorAndSelectedCell(updatedContent);
      // this.cellEditorStoreService.updateActiveSelector({...updatedContent})
    })
    /* this.cellEditorStoreService.contentElements$.subscribe((contentElements:ContentElement[]) => {
      let contentElement = contentElements.find(element => element.elId == this.selectedContent.elId);
      contentElement.horizontalAlign = layoutClass;
      //ensure only one alignment class
      this.alignments.forEach(alignment => {
        if(contentElement.classes.includes(alignment.class)){
          let itmIndx = contentElement.classes.indexOf(alignment.class);
          if(itmIndx !== -1){
            contentElement.classes.splice(itmIndx,1);
          }
        }
      })
      contentElement.classes.push(layoutClass);
      this.cellEditorStoreService.updateContentElements(contentElements);
      this.cellEditorStoreService.updateSelectorPosChange(layoutClass);
    }) */
  }
  onWidthChange(e) {
    const widthClass = e.value;
    this.cellEditorStoreService.activeSelector$.pipe(take(1)).subscribe(content => {
      console.log("content to be updated: " + content);
      // Remove existing alignment classes
      this.widthOptions.forEach(widthOption => {
        if (content.classes.includes(widthOption.value)) {
          const itmIndx = content.classes.indexOf(widthOption.value);
          if (itmIndx !== -1) {
            content.classes.splice(itmIndx, 1);
          }
        }
      })
      content.classes.push(widthClass);
      const updatedContent: ContentElement = { ...content }
      this.cellEditorStoreService.updateActiveSelectorAndSelectedCell(updatedContent);
      // this.cellEditorStoreService.updateActiveSelector({...updatedContent})
    })
  }
  setVerticalAlign(alignPosition): void {
    this.cellEditorStoreService.activeSelector$.pipe(take(1)).subscribe(content => {
      console.log("content to be updated: " + content);
      // Remove existing alignment classes
      this.valignments.forEach(valignment => {
        if (content.containerClasses.includes(valignment.class)) {
          const itmIndx = content.containerClasses.indexOf(valignment.class);
          if (itmIndx !== -1) {
            content.containerClasses.splice(itmIndx, 1);
          }
        }
      })

      content.containerClasses.push(alignPosition);
      const updatedContent: ContentElement = { ...content }
      this.cellEditorStoreService.updateActiveSelectorAndSelectedCell(updatedContent);
      // this.cellEditorStoreService.updateActiveSelector({...updatedContent})
    })
  }

  togglePopover(popover: NbPopoverDirective): void {
    popover.isShown ? popover.hide() : popover.show();
  }
}

